import { useAuth } from "@provider/context-auth";

export default function useShowRecipes() {
  const profile = useAuth()?.profile;

  return (
    profile?.email.includes("@webridge.nl") ||
    profile?.email.includes("@degroteverleiding.nl") ||
    process.env.NODE_ENV === "development"
  );
}
